const DAY_IN_MS = 24 * 60 * 60 * 1000;

// Formats conversation activity timestamps for list cards in Active and Past chat views.
export function formatConversationTimestamp(value, fallback = "") {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return String(fallback || "").trim();
  const now = Date.now();
  const elapsed = Math.abs(now - parsed.getTime());

  if (elapsed < DAY_IN_MS) {
    return new Intl.DateTimeFormat(undefined, {
      hour: "numeric",
      minute: "2-digit",
    }).format(parsed);
  }

  const currentYear = new Date(now).getFullYear();
  const timestampYear = parsed.getFullYear();
  return new Intl.DateTimeFormat(undefined, {
    month: "short",
    day: "numeric",
    ...(timestampYear === currentYear ? {} : { year: "numeric" }),
  }).format(parsed);
}
